let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("34Wij")).then(() => parcelRequire('38FZt'));